import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

import { useStyles } from './styles';

function TransitionAvatar (props) {
    const {
        calendarLogoURL = '',
        clientLogoURL = '',
        loadingIcon = '',
        marginTop = '0px',
        marginInBetween = '0px',
        isOauthFailing = false,
    } = props;

    const classes = useStyles({
        marginTop,
        marginInBetween,
        isOauthFailing,
    });
 
    return (
        <React.Fragment>
            <Grid
                id='Oauth-Avatars'
                className={classes.container}
            >
                <Avatar
                    id='Calendar-Oauth-Avatar'
                    className={classes.avatarIcon}
                    alt='Calendar Logo'
                    src={calendarLogoURL}
                    sx={{ height: '48px', width: '48px' }}
                />

                {!isOauthFailing && <Box
                    className={classes.loadingIconStyling}
                    component="img"
                    sx={{
                    //   height: 50,
                      width: 100,
                    }}
                    alt="Loading icon"
                    src={loadingIcon}
                />}

                <Avatar
                    id='Client-Oauth-Avatar'
                    className={classNames([classes.avatarIcon, classes.clientAvatarIcon])}
                    alt='Client Logo'
                    src={clientLogoURL}
                    sx={{ height: '48px', width: '48px' }}
                />
            </Grid>         
        </React.Fragment>
    );
}

TransitionAvatar.propTypes = {
    calendarLogoURL: PropTypes.string,
    clientLogoURL: PropTypes.string,
    loadingIcon: PropTypes.string,
    marginTop: PropTypes.string,
    marginInBetween: PropTypes.string,
    isOauthFailing: PropTypes.bool,
};

export default TransitionAvatar;
